import { Box, CircularProgress, Divider, Grid, Modal, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { reducerPaths } from '../../../../../app/reducerPaths';
import theme from '../../../../../theme';
import { setAlertDialog } from '../../../../../toolkit/alertDialog/alertDialogSlice';
import {
  useLazyGetAgentDetailsQuery,
  useLazyVehicleOfferPriceQuery,
} from '../../../../../toolkit/carDetails/carDetailsApi';
import {
  useLazyGetBiddersNegotiationListBuyNowQuery,
  useLazyGetBiddersNegotiationListQuery,
  useLazyGetNegotiationHistoryBuyNowDealerQuery,
  useLazyGetNegotiationHistoryDealerQuery,
} from '../../../../../toolkit/carsInNegotiation/carsInNegotiationApi';
import { useLazyGetBidHistoryQuery } from '../../../../../toolkit/liveAuction/liveAuctionApi';
import { useLazyGetVehicleQuery } from '../../../../../toolkit/vehicle/vehicleApi';
import { auctionTypes } from '../../../../../utils/constants/auction';
import { negotiationStatuses, negotiationStatusMapping } from '../../../../../utils/constants/negotiationStatuses';
import { routes } from '../../../../../utils/constants/routes';
import { getRGBAFromColor } from '../../../../../utils/methods/getCssVariables';
import { getImagesHandler } from '../../../../../utils/methods/setSellMyCarForms';
import CarDetails from '../../CarDetails';
import { mainContainer } from '../../VehicleInfoSidebarSx';
import CarBiddingNegotiationDealerBuyer from '../components/CarBiddingNegotiationDealerBuyer';
import { useCarsInNegotiationSocketEvents } from '../customHooks/useCarsInNegotiationDealerSocketEvents';
import CarDetailSkeleton from '../../CarDetailsSkeleton';

const CarsInNegotiationDetailsDealerBuyer = ({
  Bid_Id,
  myCarsOrOtherCars,
  // selectedCar,
  // setSelectedCar,
}) => {
  const images = [
    'https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480',
    'https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480',
    'https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480',
  ];

  const { t } = useTranslation('carsInNegotiationDetails');
  const { t: buyNowCarDetailReadOnly } = useTranslation('buyNowCarDetailReadOnly');

  const isMobile = useMediaQuery('(max-width:1300px)');

  const navigate = useNavigate();

  // useLocation...
  const location = useLocation();
  // useLocation...

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useSelector...
  const auth = useSelector((store) => store[reducerPaths.auth]);
  // useSelector...

  // const Vehicle_Id = parseInt(location?.pathname?.split?.(`${routes.carsInNegotiation}/`)?.[1]);
  const Vehicle_Id = parseInt(
    location?.pathname?.split?.(`${routes.carsInNegotiation}/`)?.[1] ||
      location?.pathname?.split?.(`${routes.carsInNegotiationBuyNow}/`)?.[1]
  );

  const liveAuctionOrBuyNow = location?.pathname?.includes?.(`${routes.carsInNegotiationBuyNow}`)
    ? auctionTypes.buyNow
    : auctionTypes.liveAuction;

  // useState variables start...
  const [selectedCar, setSelectedCar] = React.useState(null);
  const [activeBidder, setActiveBidder] = React.useState(null);
  const [index, setIndex] = React.useState(0);
  // useState variables end...

  const [sellerId, setSelletId] = React.useState(null);
  const [dealerId, setDealerId] = React.useState(null);
  const [negotiationStatus, setNegotiationStatus] = React.useState(negotiationStatuses.ongoing);
  const [scrollToBottom, setScrollToBottom] = React.useState(true);

  // Handlers start...
  const handleNext = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const parsedVehicle = (selectedCar) => {
    const images = [];
    const carImages = getImagesHandler({
      data: {
        vehicle: selectedCar,
      },
    });

    for (let i = 0; i < Object.entries(carImages?.images)?.length; i++) {
      for (let j = 0; j < Object.entries(carImages?.images)?.[i]?.[1]?.length; j++) {
        if (Object.entries(carImages?.images)?.[i]?.[1]?.[j]) {
          images.push(Object.entries(carImages?.images)?.[i]?.[1]?.[j]);
        }
      }
    }

    return {
      ...selectedCar,
      images,
    };
  };

  const onNewCounterOfferHandler = async (e) => {
    console.log(e, `onNewCounterOfferHandler`);
    if (liveAuctionOrBuyNow === auctionTypes.liveAuction) {
      await getNegotiationHistoryApiHandler({
        Vehicle_Id,
      });
    } else {
      await getNegotiationHistoryBuyNowApiHandler({
        Vehicle_Id,
      });
    }

    if (e?.senderId === auth?.user_id) {
      setScrollToBottom(true);
    }
  };

  const onBidAcceptedHandler = async (e) => {
    // dispatch(
    //   setAlertDialog({
    //     open: true,
    //     title: `Alert!`,
    //     message: `Negotiation has been accepted!`,
    //     onClose: () => {
    //       navigate(`${routes.dashboardNavigation}${routes.carsInNegotiation}`)
    //     }
    //   })
    // )
    setNegotiationStatus(negotiationStatuses.accepted);
  };

  const onBidDeclinedHandler = async (e) => {
    // dispatch(
    //   setAlertDialog({
    //     open: true,
    //     title: `Alert!`,
    //     message: `Negotiation has been declined!`,
    //     onClose: () => {
    //       navigate(`${routes.dashboardNavigation}${routes.carsInNegotiation}`)
    //     }
    //   })
    // )
    setNegotiationStatus(negotiationStatuses.decline);
  };
  // Handlers end...

  // custom hooks start...
  const [getVehicleApiHandler, getVehicleApiData] = useLazyGetVehicleQuery();
  const [getAgentDetailsApiHandler, getAgentDetailsApiData] = useLazyGetAgentDetailsQuery();
  const [getNegotiationHistoryApiHandler, getNegotiationHistoryApiData] = useLazyGetNegotiationHistoryDealerQuery();
  const [getNegotiationHistoryBuyNowApiHandler, getNegotiationHistoryBuyNowApiData] =
    useLazyGetNegotiationHistoryBuyNowDealerQuery();
  const [getBidHistoryApiHandler, getBidHistoryApiData] = useLazyGetBidHistoryQuery();
  const [getBiddersNegotiationListApiHandler, getBiddersNegotiationListApiData] =
    useLazyGetBiddersNegotiationListQuery();
  const [getBiddersNegotiationListBuyNowApiHandler, getBiddersNegotiationListBuyNowApiData] =
    useLazyGetBiddersNegotiationListBuyNowQuery();
  const [vehicleOfferPriceApiHandler, vehicleOfferPriceApiData] = useLazyVehicleOfferPriceQuery();
  useCarsInNegotiationSocketEvents({
    Vehicle_Id,
    sellerId,
    dealerId: activeBidder?.Dealer_Id || '',
    myCarsOrOtherCars,
    onNewCounterOfferHandler,
    onBidAcceptedHandler,
    onBidDeclinedHandler,
  });
  // custom hooks end...

  // useEffect start...
  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getVehicleApiHandler({
          Vehicle_Id,
        });

        console.log(res, `getVehicleApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error`,
              message:
                res?.error?.data?.error ||
                res?.error?.data?.message ||
                `Some error occured in fetching the car details!`,
            })
          );
        } else {
          setSelectedCar(res?.data?.vehicle);
          setSelletId(res?.data?.vehicle?.Seller_Id || '');
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getAgentDetailsApiHandler({
          vehicleId: Vehicle_Id,
        });

        console.log(res, `getAgentDetailsApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error`,
              message: res?.error?.data?.error || res?.error?.data?.message || `Some error occured!`,
            })
          );
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (!Vehicle_Id) {
      return;
    }

    console.log(liveAuctionOrBuyNow, `getNegotiationHistoryBuyNowApiHandler`);
    (async () => {
      if (liveAuctionOrBuyNow === auctionTypes.liveAuction) {
        await getNegotiationHistoryApiHandler({
          Vehicle_Id,
        });
      } else {
        await getNegotiationHistoryBuyNowApiHandler({
          Vehicle_Id,
        });
      }
    })();
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (!Vehicle_Id) {
      return;
    }

    (async () => {
      await getBidHistoryApiHandler({
        vehicleId: Vehicle_Id,
      });
    })();
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (!Vehicle_Id) {
      return;
    }

    (async () => {
      let res;

      if (liveAuctionOrBuyNow === auctionTypes.liveAuction) {
        res = await getBiddersNegotiationListApiHandler({
          Vehicle_Id,
        });
      } else {
        res = await getBiddersNegotiationListBuyNowApiHandler({
          Vehicle_Id,
        });
      }

      const currDealer = liveAuctionOrBuyNow === auctionTypes.liveAuction ? res?.data?.TopBids?.find?.(bid => {
        return (parseInt(bid?.Dealer_Id) === auth?.user_id);
      }) : res?.data?.TopBids;


      setNegotiationStatus(negotiationStatusMapping[currDealer?.negotation_status]);

      if (currDealer?.bidder_status === 'inactive') {
        dispatch(
          setAlertDialog({
            open: true,
            title: `Error!`,
            message: 'You cannot bid right now.',
          })
        );

        navigate(
          `${routes.dashboardNavigation}${
            liveAuctionOrBuyNow === auctionTypes.liveAuction ? routes.carsInNegotiation : routes.carsInNegotiationBuyNow
          }`
        );
      }
    })();
  }, [Vehicle_Id]);

  React.useEffect(() => {
    const activeBidder =
      liveAuctionOrBuyNow === auctionTypes.liveAuction
        ? getBiddersNegotiationListApiData?.data?.TopBids?.find?.((bid) => {
            return bid?.bidder_status === 'active';
          })
        : getBiddersNegotiationListBuyNowApiData?.data?.TopBids;

    setActiveBidder({
      ...activeBidder,
      Dealer_Id: parseInt(activeBidder?.Dealer_Id),
    });
  }, [
    getBiddersNegotiationListApiData?.data?.TopBids,
    getBiddersNegotiationListBuyNowApiData?.data?.TopBids,
    liveAuctionOrBuyNow,
  ]);

  React.useEffect(() => {
    if (!Bid_Id) {
      navigate(
        `${routes.dashboardNavigation}${
          liveAuctionOrBuyNow === auctionTypes.liveAuction ? routes.carsInNegotiation : routes.carsInNegotiationBuyNow
        }`
      );
    }
  }, [Bid_Id]);

  React.useEffect(() => {
    if (
      selectedCar?.Vehicle_Id &&
      selectedCar?.VIN &&
      selectedCar?.Mileage &&
      selectedCar?.Trim &&
      selectedCar?.Year &&
      selectedCar?.Make &&
      selectedCar?.Model
    ) {
      (async () => {
        await vehicleOfferPriceApiHandler({
          storedVehicleId: selectedCar?.Vehicle_Id,
          params: {
            vin: selectedCar?.VIN,
            mileage: selectedCar?.Mileage,
            trim: selectedCar?.Trim,
            year: selectedCar?.Year,
            make: selectedCar?.Make,
            model: selectedCar?.Model,
          }
        });
      })();
    }
  }, [selectedCar]);
  // useEffect end...

  console.log(getNegotiationHistoryApiData, activeBidder, `getNegotiationHistoryApiData`);

  return (
    <>
      <Grid container spacing={0} sx={mainContainer}>
        {/* Left Section - 28.5% */}
        {getVehicleApiData?.isFetching || !selectedCar ? (
          <CarDetailSkeleton />
        ) : (
          <>
            <Grid
              size={{ xl: 2.8 - 0.2, lg: 4 - 0.2, md: 12, sm: 12, xs: 12 }}
              sx={{
                width: isMobile ? '100%' : '28%',
                backgroundColor: getRGBAFromColor({
                  color: theme.palette.primary.main,
                  alpha: '0.085',
                }),
                padding: '1.5rem',
                borderRadius: '1rem',
                boxShadow: '0 0.25rem 0.5rem rgba(0, 0, 0, 0.1)',
              }}
            >
              {negotiationStatus === negotiationStatuses.accepted ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#2BD24C',
                    padding: '1rem',
                    borderRadius: '1rem',
                    marginBottom: '1rem',
                  }}
                >
                  <Typography
                    sx={{
                      color: theme.palette.background.paper,
                    }}
                  >
                    {t('Offer accepted. Sale completed successfully.')}
                  </Typography>
                </Box>
              ) : null}

              {negotiationStatus === negotiationStatuses.decline ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#D22B2B',
                    padding: '1rem',
                    borderRadius: '1rem',
                    marginBottom: '1rem',
                  }}
                >
                  <Typography
                    sx={{
                      color: theme.palette.background.paper,
                    }}
                  >
                    {buyNowCarDetailReadOnly('The offer was declined. No deal was made.')}
                  </Typography>
                </Box>
              ) : null}

              <CarBiddingNegotiationDealerBuyer
                selectedCar={selectedCar}
                Vehicle_Id={Vehicle_Id}
                Bid_Id={Bid_Id}
                negotiationHistory={
                  liveAuctionOrBuyNow === auctionTypes.liveAuction
                    ? getNegotiationHistoryApiData?.data?.negotiations_history1?.filter?.((bid) => {
                        return parseInt(bid?.dealer_id) === activeBidder?.Dealer_Id;
                      }) || []
                    : getNegotiationHistoryBuyNowApiData?.data?.negotiations_history1?.filter?.((bid) => {
                        return parseInt(bid?.dealer_id) === activeBidder?.Dealer_Id;
                      }) || []
                }
                negotiationStatus={negotiationStatus}
                negotiationStatuses={negotiationStatuses}
                isLoading={
                  liveAuctionOrBuyNow === auctionTypes.liveAuction
                    ? getNegotiationHistoryApiData?.isFetching
                    : getNegotiationHistoryBuyNowApiData?.isFetching
                }
                firstBid={
                  liveAuctionOrBuyNow === auctionTypes.liveAuction
                    ? getBiddersNegotiationListApiData?.data?.TopBids?.find?.((bid) => {
                        return parseInt(bid?.Dealer_Id) === activeBidder?.Dealer_Id;
                      })
                    : getBiddersNegotiationListBuyNowApiData?.data?.TopBids
                }
                auctionType={routes.carsInNegotiation}
                scrollToBottom={scrollToBottom}
                setScrollToBottom={setScrollToBottom}
              />
            </Grid>
            <Divider orientation={'vertical'} flexItem />
            {/* Right Section - 70% */}
            <Grid size={{ xl: 9.2 - 0.2, lg: 8 - 0.2, md: 12, sm: 12, xs: 12 }}>
              <CarDetails car={parsedVehicle(selectedCar)} />
            </Grid>
          </>
        )}
      </Grid>

      {/* Left Section - 28.5% */}
      {/* <Box
        sx={{
          width: isMobile ? "100%" : "28.5%",
          backgroundColor: getRGBAFromColor({
            color: theme.palette.primary.main,
            alpha: "0.085"
          }),
          padding: "1.5rem",
          borderRadius: "1rem",
          boxShadow: "0 0.25rem 0.5rem rgba(0, 0, 0, 0.1)",
        }}
      >
        {currentLeftSidebarTab.component}
      </Box> */}
    </>
  );
};

export default CarsInNegotiationDetailsDealerBuyer;
